import LabelBox from './LabelBox';
export default LabelBox;


// WEBPACK FOOTER //
// ./src/components/LabelBox/index.js